<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "LPO Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, ModelListSelect },
  data() {
    return {
      title: "LOCAL PURCHASE ORDER DETAILS",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "LPO Details",
          active: true,
        },
      ],
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: this.$route.params.id,
      editSup: {
        orderId: this.$route.params.id,
        supplier: "",
      },
      data: {
        orderId: this.$route.params.id,
        item: "",
        type: 1,
        quantity: "",
        price: "",
      },
      other: {
        orderId: this.$route.params.id,
        item: "",
        type: 0,
        quantity: "",
        price: "",
      },
      deletedata: {
        orderId: this.$route.params.id,
        item: "",
      },
      modal_id: "",
      itemError: "",
      qtyError: "",
      priceError: "",
      supError: "",
      total_amount:0,
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("purchaseOrder", ["purchaseOrder", "GeneratingStatus"]),
    ...mapGetters("sales", ["PharmacyStock"]),
    ...mapGetters("pharmacy", ["Suppliers"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapGetters("inventory", ["LabItems"]),
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.closeModal(this.modal_id);
          this.resetData();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchOrder: "purchaseOrder/fetchPurchaseOrderDetails",
      AddItem: "purchaseOrder/addItem",
      ChangeSupplier: "purchaseOrder/changeSupplier",
      ApproveLPO: "purchaseOrder/approveLPO",
      DeleteItem: "purchaseOrder/deleteItem",
      FetchOtherItems: "sales/fetchPharmacyItems",
      FetchSuppliers: "pharmacy/fetchSuppliers",
      FetchLabItem: "inventory/fetchLabItems",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    resetData() {
      this.modal_id = "";
      this.editSup.supplier = "";
      this.data.item = "";
      this.data.quantity = "";
      this.data.price = "";
      this.deletedata.item = "";
      this.other.item = "";
      this.other.quantity = "";
      this.other.price = "";
    },
    resetErrors() {
      this.itemError = "";
      this.qtyError = "";
      this.supError = "";
      this.priceError = "";
    },

    addItem() {
      //this.modal_id = modalId;
      if (this.data.item == "") {
        this.itemError = "Please select an item to add";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.qtyError = "Please enter quantity to add";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.data.price == "") {
        this.priceError = "Please enter price per unit";
        return;
      } else {
        this.priceError = "";
      }
      this.AddItem(this.data);
    },

    saveItem() {
      //this.modal_id = modalId;
      if (this.other.item == "") {
        this.itemError = "Please select an item to add";
        return;
      } else {
        this.itemError = "";
      }
      if (this.other.quantity == "") {
        this.qtyError = "Please enter quantity to add";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.other.price == "") {
        this.priceError = "Please enter price per unit";
        return;
      } else {
        this.priceError = "";
      }
      this.AddItem(this.other);
    },
    changeSup(modalId) {
      this.modal_id = modalId;
      if (this.editSup.supplier == "") {
        this.supError = "Please select a supplier";
        return;
      } else {
        this.supError = "";
      }
      this.ChangeSupplier(this.editSup);
    },
    approveLPOx() {
      this.ApproveLPO({ id: this.id });
    },
    delItem(value) {
      this.deletedata.item = value;
      this.DeleteItem(this.deletedata);
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  updated() {
    let total_amount = 0;
      if(this.purchaseOrder){
        this.purchaseOrder.orderItems.forEach((item)=>{
          total_amount = total_amount+parseInt(item.quantity*item.unit_price);
        });
        this.total_amount = total_amount;
      }
  },
  created() {
    this.FetchOrder(this.id);
    this.FetchOtherItems();
    this.FetchSuppliers();
    this.FetchLabItem();
  },
};
</script>

<style scoped>
.print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
}
@media print {
  .no-print {
    visibility: hidden;
  }
}
</style>

<template>
  <Layout>
    <Toasts
        :show-progress="true"
        :rtl="true"
        :max-messages="20"
        :time-out="3000"
        :closeable="false"
        :solid="true"
    ></Toasts>
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a v-if="purchaseOrder.orderStatus==1" href="javascript:window.print()" class="btn btn-primary waves-effect waves-light me-1">
              <i class="fa fa-print"></i> Print LPO
            </a>
            <div class="btn-group" v-if="purchaseOrder.orderStatus==0">
              <button v-if="user_permissions.approve_lpo==1" @click="approveLPOx()" class="btn btn-primary">
                <i class="fa fa-check"></i> APPROVE
              </button>
              <button v-b-modal.edit-supplier v-if="user_permissions.change_lpo_supplier==1" class="btn btn-info">
                <i class="fa fa-edit"></i> SUPPLIER
              </button>
              <button v-b-modal.add-item v-if="user_permissions.add_lpo_item==1" class="btn btn-success">
                <i class="fa fa-plus"></i> PHARMACY
              </button>
              <button v-b-modal.other-item v-if="user_permissions.add_lpo_item==1" class="btn btn-dark">
                <i class="fa fa-plus"></i> OTHERS
              </button>
            </div>
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white text-dark">
          <div class="print-font m-2 text-dark" v-if="!purchaseOrder.clinicLogo">
            <div style="text-align: center;">
              <b-spinner
                  class="m-0"
                  variant="primary"
                  role="status"
              ></b-spinner>
            </div>
          </div>
          <div class="print-font m-2 text-dark" v-else>
            <div style="width: 100%; float: left; top: 0; text-align: center;">
              <img :src="purchaseOrder.clinicLogo" width="250"/>
            </div>
            <div style="width: 100%; top: 0; height: 130px">
              <div style="width: 50%; float: left; top: 0">
                <h3 class="text-uppercase">
                  <strong>{{ purchaseOrder ? purchaseOrder.clinicName : "---" }}</strong>
                </h3>
                <table width="100%">
                  <tr>
                    <td v-html="purchaseOrder ? purchaseOrder.clinicAddress : '---'"></td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Tel:</strong>
                      {{ purchaseOrder ? "+256" + purchaseOrder.clinicPhone : "---" }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Email:</strong>
                      {{ purchaseOrder ? purchaseOrder.clinicEmail : "---" }}
                    </td>
                  </tr>
                </table>
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <h3 class="text-uppercase text-end">
                  <strong>PURCHASE ORDER</strong>
                </h3>
                <table width="100%">
                  <tr align="right">
                    <td><strong>ORDER CODE: </strong> {{purchaseOrder.orderCode}}</td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>ORDER DATE:</strong>
                      {{ purchaseOrder.orderDate }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>PRINT DATE:</strong>
                      {{ purchaseOrder.printDate }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div style="width: 100%; top: 0; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <h3 class="text-uppercase">
                  <strong>SUPPLIER</strong>
                </h3>
                <table width="100%">
                  <tr>
                    <td>{{purchaseOrder.orderSupplier.name ? purchaseOrder.orderSupplier.name : "---"}}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Tel:</strong>
                      {{ purchaseOrder.orderSupplier.contact }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Email:</strong>
                      {{ purchaseOrder.orderSupplier.email }}
                    </td>
                  </tr>
                </table>
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <h3 class="text-uppercase text-end">
                  <strong>DELIVER TO:</strong>
                </h3>
                <table width="100%">
                  <tr align="right">
                    <td>
                      {{ purchaseOrder ? purchaseOrder.clinicName : "---" }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td v-html="purchaseOrder ? purchaseOrder.clinicAddress : '---'"></td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Tel:</strong>
                      {{ purchaseOrder ? "+256" + purchaseOrder.clinicPhone : "---" }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
              <table width="100%" class="table table-striped" style="font-size: 15px">
                  <thead>
                    <tr>
                      <th>S/N</th>
                      <th>Item</th>
                      <th>Quantity</th>
                      <th>Unit Price</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(record, r) in purchaseOrder.orderItems" :key="r">
                      <td>{{ r + 1 }}</td>
                      <td>{{ record.item }}</td>
                      <td>{{ record.quantity }}</td>
                      <td>{{ record.unit_price }}</td>
                      <td>
                        {{ record.total }}
                      <span class="no-print" v-if="purchaseOrder.orderStatus==0">
                        <button
                          @click="delItem(record.id)" class="btn btn-danger btn-sm">
                        <i class="fa fa-trash"></i>
                      </button>
                      </span>
                      </td>
                    </tr>
                    <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total <h4 style="color:green;">{{purchaseOrder.ItemsTotal}}</h4></td>
                    </tr>
                  </tbody>
                </table>
                 <div class="row">
                  <div class="col-md-3"></div>
                  <div class="col-md-4">
                    <h5>Total Amount: <span class="text-danger">{{thousandSeprator(total_amount)}}</span></h5>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
    <!-- edit modal starts -->
    <b-modal id="edit-supplier" hide-footer @hidden="resetData">
      <template #modal-title> CHANGE SUPPLIER</template>
      <div class="form-group mb-3">
        <label>Supplier</label>
        <model-list-select
          :list="Suppliers ? Suppliers : []"
          v-model="editSup.supplier"
          option-value="id"
          option-text="name"
          placeholder="Select Supplier"
          @input="resetErrors()"
        >
        </model-list-select>
      </div>
      <div class="text-danger" v-if="supError">
        <em>{{ supError }}</em>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-supplier')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="changeSup('edit-supplier')">
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="GeneratingStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
    <b-modal id="add-item" hide-footer @hidden="resetData">
      <template #modal-title> ADD NEW ITEM</template>
      <div class="form-group mb-3">
        <label>Select Item</label>
        <model-list-select
          :list="PharmacyStock ? PharmacyStock : []"
          v-model="data.item"
          option-value="id"
          option-text="drug_name"
          placeholder="Select Item"
          @input="resetErrors()"
        >
        </model-list-select>
      </div>
      <div class="text-danger" v-if="itemError">
        <em>{{ itemError }}</em>
      </div>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          v-model="data.quantity"
          @input="resetErrors()"
          placeholder="Enter Quantity"
        />
      </div>
      <div class="text-danger" v-if="qtyError">
        <em>{{ qtyError }}</em>
      </div>
      <div class="form-group mb-3">
        <label>Price per Unit</label>
        <input
            type="number"
            class="form-control"
            v-model="data.price"
            @input="resetErrors()"
            placeholder="Enter Price per Unit"
        />
      </div>
      <div class="text-danger" v-if="priceError">
        <em>{{ priceError }}</em>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-item')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="addItem()">
          <i class="fa fa-check"></i>
          Add Item
          <b-spinner
            v-if="GeneratingStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
    <b-modal id="other-item" hide-footer @hidden="resetData">
      <template #modal-title> ADD CONSUMABLES</template>
      <div class="form-group mb-3">
        <label>Select Item</label>
        <model-list-select
            :list="LabItems ? LabItems : []"
            v-model="other.item"
            option-value="id"
            option-text="itemName"
            placeholder="Select Item"
            @input="resetErrors()"
        >
        </model-list-select>
      </div>
      <div class="text-danger" v-if="itemError">
        <em>{{ itemError }}</em>
      </div>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
            type="number"
            class="form-control"
            v-model="other.quantity"
            @input="resetErrors()"
            placeholder="Enter Quantity"
        />
      </div>
      <div class="text-danger" v-if="qtyError">
        <em>{{ qtyError }}</em>
      </div>
      <div class="form-group mb-3">
        <label>Price per Unit</label>
        <input
            type="number"
            class="form-control"
            v-model="other.price"
            @input="resetErrors()"
            placeholder="Enter Price per Unit"
        />
      </div>
      <div class="text-danger" v-if="priceError">
        <em>{{ priceError }}</em>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('other-item')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="saveItem()">
          <i class="fa fa-check"></i>
          Add Item
          <b-spinner
              v-if="GeneratingStatus"
              variant="light"
              small
              label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <div class="row">
      <div class="col-md-6">
        <h5>Generated By:</h5><br>
        ------------------------------
      </div>
      <div class="col-md-3">
      </div>
      <div class="col-md-3">
        <h5>Approved By:</h5><br>
        ------------------------------
      </div>
    </div>
    <!-- modal ends -->
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
